const RATING_COLORS = {
  Green: {
    bg: "bg-green-100",
    text: "text-green-700",
    ring: "ring-green-600/20",
    dot: "bg-green-500",
  },
  Yellow: {
    bg: "bg-yellow-100",
    text: "text-yellow-700",
    ring: "ring-yellow-600/20",
    dot: "bg-yellow-500",
  },
  Red: {
    bg: "bg-red-100",
    text: "text-red-700",
    ring: "ring-red-600/20",
    dot: "bg-red-500",
  },
};

export function getRatingColors(rating = "Green") {
  return RATING_COLORS[rating] || RATING_COLORS.Green;
}

export function formatScoreAsPercentage(score, decimals = 1) {
  if (typeof score !== "number" || Number.isNaN(score)) return "N/A";
  return (score * 100).toFixed(decimals);
}

export function collectVendorRiskRatings(vendor = {}) {
  const fromRequests = [...(vendor.myRequests || []), ...(vendor.libraryRequests || [])]
    .filter((req) => req.riskScore?.rating)
    .map((req) => req.riskScore.rating);
  if (fromRequests.length) return fromRequests;
  return vendor.documentRiskRatings || [];
}
